import type { ReactNode } from "react";
import { memo } from "react";

import type { InvoiceFilter } from "~/shared/types/payment-types.ts";

import { SummaryCard } from "../summary-card/summary-card.tsx";

type SummaryData = {
	amount: number;
	icon: ReactNode;
	count: number;
	label: string;
};

type SummaryCardsProps = {
	data: Partial<Record<InvoiceFilter, SummaryData>>;
	handleFilterChange: (filter: InvoiceFilter) => void;
	selectedFilter?: InvoiceFilter | null;
};

export const SummaryCards = memo<SummaryCardsProps>(
	({ data, handleFilterChange, selectedFilter }: SummaryCardsProps) => {
		return (
			<div className={"summary-cards"}>
				{Object.entries(data).map(([key, value]) => (
					<SummaryCard
						key={key}
						filter={key as InvoiceFilter}
						handleFilterChange={handleFilterChange}
						isSelected={selectedFilter === key}
						title={value.label}
						value={value}
					/>
				))}
			</div>
		);
	},
);

SummaryCards.displayName = "SummaryCards";
